import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import { Box } from "@mui/material";
import FormControl from "@mui/material/FormControl";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import { ReactElement } from "react";

import { AssetTypes } from "../../../generated/gql/graphql";
import useText from "../../../hooks/use-text";
import { LocalizedStrings, SupportedLanguages } from "../../../utils/lang";
import { cn } from "../../../utils/utils";

import { styles } from "./metashot-type-filter";

type Props = {
  className?: string;
  value?: AssetTypes;
  onSelect(value: AssetTypes | "all"): void;
};

export default function AssetTypeFilter(props: Props): ReactElement {
  const { className, value, onSelect } = props;

  const { strings } = useText(local);

  const options = Object.keys(AssetTypes).map((t) => t);

  return (
    <Box sx={styles}>
      <FormControl
        style={{ minWidth: 150, maxWidth: 200 }}
        size="small"
        className="disabled:cursor-not-allowed "
      >
        <InputLabel className="text-[14px]">{strings.label}</InputLabel>
        <Select
          className={cn(
            "border-0 rounded-[15px] text-[14px] text-left",
            className
          )}
          disabled={options.length === 0}
          label={strings.label}
          value={value?.toString() ?? "all"}
          displayEmpty
          onChange={(v) => onSelect(v.target.value as AssetTypes)}
          IconComponent={KeyboardArrowDownIcon}
        >
          <MenuItem value="all">{strings.options.all}</MenuItem>
          {options &&
            options.map((item) => (
              <MenuItem className="capitalize" key={item} value={item}>
                {item}
              </MenuItem>
            ))}
        </Select>
      </FormControl>
    </Box>
  );
}

type LocalSchema = {
  label: string;
  options: {
    all: string;
  };
};

const local: LocalizedStrings<LocalSchema, SupportedLanguages> = {
  default: {
    label: "Asset Types",
    options: {
      all: "All",
    },
  },
};
